import React from 'react';

const DescriptionAboutService = ({ProductData}) => {


    return (
        <div >
            <div className="border rounded-lg p-6 shadow-sm">
                <div className="p-[10px] border-b border-[#3333338a]">
                    <h1 className="text-[#333] text-xl font-semibold ps-[10px]">Description About Service</h1>
                </div>
                <div className="flex flex-col gap-[20px] py-5">
                    <div className='border-b border-[#DADCE0] pb-[10px]'>
                        <p className="font-semibold text-[#333] mb-[5px]">Service Description:</p>
                        <p className="text-[#555] leading-relaxed px-[60px]">{ProductData.p_description}</p>
                    </div>
                    <div className='border-b border-[#DADCE0] pb-[10px]'>
                        <p className="font-semibold text-[#333] mb-[5px]">Service Variants:</p>
                        <p className="text-[#555] leading-relaxed px-[60px]">{ProductData.p_varient}</p>
                    </div>
                    <div className='border-b border-[#DADCE0] pb-[10px]'>
                        <p className="font-semibold text-[#333] mb-[5px]">Service Certification:</p>
                        <p className="text-[#555] leading-relaxed px-[60px]">{ProductData.p_certification}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DescriptionAboutService;
